import { h, Component } from 'preact';
import Store from 'store/store';
import 'store/bolt';
import Link from 'components/bolt/link/link';
// import DynamicTheaterSentence from 'components/shared/dynamicTheaterSentence/dynamicTheaterSentence';
// import { getCopy } from 'utils/copy';
import { accessNested, joinClasses, triggerAnim, parseDate } from 'utils/utils';
import formatDateTime from 'utils/formatDateTime';
import { geoFromIP, geoSearchOne } from 'utils/bolt/geo';
import { getShowtimes, getAvailableFilters } from 'utils/bolt/showtimes';
import { replaceWithVNode } from 'utils/vnode';

import s from 'base/boltBanner/boltBanner.sss';
const isServer = typeof window === 'undefined';
const mobileBreakpoint = 680;
// Duration (ms) of a full cycle theater count + theater name
const animationDuration = 10000;

function toQueryString(obj) {
	if (!obj) {
		return '';
	}
	let parts = Object.keys(obj).map(key => {
		let val = obj[key];
		if (!key || val === false || val == null) {
			return;
		}
		let part = encodeURIComponent(key);
		if (val !== true) {
			part += '=' + encodeURIComponent(val);
		}
		return part;
	}).filter(e => e);
	return parts.length ? '?' + parts.join('&') : '';
}
let color = v => typeof v !== 'string' || v.startsWith('#') ? v : '#' + v;
let size = v => typeof v !== 'string' || v.endsWith('px') ? v : v + 'px';

export default class BoltBannerApp extends Component {
	constructor(props) {
		super();
		this.onResize = this.onResize.bind(this);

		this.state = {
			mobile: isServer || window.innerWidth <= mobileBreakpoint,
			loading: true,
			theaters: [],
			activeTheater: -1,
			appState: props.initialStore,
			data: accessNested(props.initialStore, 'appData.pages.boltBanner.data') || {}
		};
		Store.set(props.initialStore);

		this.qs = {};
		if (!isServer) {
			this.qs = location.search.substr(1).split('&').reduce((qs, el) => {
				const [name, ...value] = el.split('=');
				qs[name] = value.length ? value.join('=') : true;
				return qs;
			}, {});
		}

		this.preRelease = new Date() < parseDate(accessNested(props.initialStore, 'appData.meta.dates.release'));
		this.settings = Object.assign({
			textColor: '#000000',
			highlightTextColor: '#0b87ee',
			backgroundColor: '#ffffff',
			buttonTextColor: '#ffffff',
			buttonBackgroundColor: '#0b87ee',
			textFontSize: '24',
			buttonFontSize: '14',
		}, this.qs);
		this.mobileSettings = { ...this.settings };
		Object.keys(this.qs).forEach(key => {
			if (!key.startsWith('mobile') || key === 'mobile') {
				return;
			}
			let keyToOverride = key.replace(/^mobile(.)/, (m, l) => l.toLowerCase());
			this.mobileSettings[keyToOverride] = this.qs[key];
		});

		this.appUrl = props.initialStore.url || '';
		this.appQS = [
			'campaign',
			...Object.keys(this.qs).filter(e => e.startsWith('utm_'))
		].reduce((appQS, key) => {
			if (this.qs[key]) {
				appQS[key] = this.qs[key];
			}
			return appQS;
		}, {});

		Store.on('update', () => this.setState({ appState: Store.get() }));
	}

	async componentDidMount() {
		window.addEventListener('resize', this.onResize);

		let location = geoFromIP;
		if (this.settings.location) {
			location = () => geoSearchOne({ search: this.settings.location });
		}
		Store.emit('SET_USER_LOCATION', location, 'landing');

		let apiResponse;
		let dates = formatDateTime(new Date(), 'yyyy\\-MM\\-dd');
		try {
			let filters = await getAvailableFilters();
			dates = (accessNested(filters, 'response.dates') || []).find(e => e >= dates) || dates;
			apiResponse = await getShowtimes({ filters: { date: dates }, limit: 5 });
		} catch (err) {
			let error = (err && err.message) || err;
			this.setState({ loading: false, error, theaters: [] });
			console.log(err);
			return;
		}

		let data = apiResponse.response.data;
		let chains = apiResponse.response.included.chains;
		data.forEach(theater => {
			theater.chain = chains[theater.chainId];
		});
		this.setState({ loading: false, theaters: data, activeTheater: 0 });
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.activeTheater !== this.state.activeTheater) {
			this.runSentencesAnimation();
		}
	}

	onResize() {
		let newIsMobile = window.innerWidth <= mobileBreakpoint;
		if (newIsMobile !== this.state.mobile) {
			this.setState({ mobile: newIsMobile });
		}
	}

	runSentencesAnimation() {
		if (!this.$sentences) {
			return;
		}
		triggerAnim(this.$sentences, s.animate);
		clearTimeout(this.sentencesTimer);
		let next = (this.state.activeTheater + 1) % this.state.theaters.length;
		this.sentencesTimer = setTimeout(() => this.setState({ activeTheater: next }), animationDuration);
	}

	addDateFormat(copy) {
		if (!copy.includes('%EMBED_RELEASE_DATE%')) {
			return copy;
		}
		const releaseDate = parseDate(accessNested(this.props.initialStore, 'appData.meta.dates.release'));
		const formattedReleaseDate = formatDateTime(releaseDate, this.state.data.dateFormat || 'dd MMMM yyyy');
		return copy.replace('%EMBED_RELEASE_DATE%', formattedReleaseDate);
	}

	getCopy(varAfterRelease, varBeforeRelease, defaultAfter, defaultBefore) {
		let data = this.state.data;
		let after = data[varAfterRelease];
		let before = data[varBeforeRelease];
		let result = this.preRelease ? before || after : after || before;
		if (result) {
			return this.addDateFormat(result);
		}
		return this.addDateFormat(this.preRelease ? defaultBefore || defaultAfter : defaultAfter || defaultBefore);
	}

	getLink(theater) {
		let qs = this.appQS;
		if (theater && theater.lat && theater.lon) {
			qs = {
				...qs,
				lat: theater.lat,
				lon: theater.lon,
				location: accessNested(theater, 'address.local.city') || accessNested(theater, 'address.intl.city'),
			};
		}
		return this.appUrl + toQueryString(qs);
	}

	getNoTheaterSentence() {
		let sentence = this.getCopy('noResultsCopy', 'noResultsBeforeReleaseCopy', 'Now playing in theaters', 'Tickets available');
		return <span key="no-theater">{sentence}</span>;
	}

	getSingleTheaterSentence(theater, settings) {
		let sentence = this.getCopy(
			'theaterCopy', 'theaterBeforeReleaseCopy',
			'Now playing in %THEATER%',
			'Tickets available in %THEATER%'
		);
		sentence = replaceWithVNode(
			sentence,
			'%THEATER%',
			<span class={s.highlight} style={{ color: color(settings.highlightTextColor) }}>
				{theater.name}
			</span>
		);
		return (
			<Link
				class={s.sentence}
				href={this.getLink(theater)}
				target="_blank"
				key={theater.id || 'single'}
			>
				{sentence}
			</Link>
		);
	}

	getTheatersCountSentence(count, settings) {
		let sentence = this.getCopy(
			'countCopy', 'countBeforeReleaseCopy',
			'Now playing in {%THEATER_COUNT% theatres nearby}',
			'Tickets available in {%THEATER_COUNT% theatres nearby}'
		);
		sentence = replaceWithVNode(
			sentence.replace(/%THEATER_COUNT%/g, count),
			/\{([^}]+)\}/g,
			(match) => (
				<span class={s.highlight} style={{ color: color(settings.highlightTextColor) }}>
					{match[1]}
				</span>
			)
		);
		return (
			<Link
				class={s.sentence}
				href={this.getLink()}
				target="_blank"
				key="count"
			>
				{sentence}
			</Link>
		);
	}

	getSentence(settings) {
		let theaters = this.state.theaters;
		if (!theaters || !theaters.length) {
			return this.getNoTheaterSentence();
		}
		if (theaters.length === 1) {
			return this.getSingleTheaterSentence(theaters[0], settings);
		}
		// More than one
		let theater = theaters[this.state.activeTheater % theaters.length];
		let animStyle = { animationDuration: animationDuration + 'ms' };
		return (
			<div class={s.sentences} ref={e => this.$sentences = e} key="sentences">
				<div class={s.count} style={animStyle}>
					{this.getTheatersCountSentence(theaters.length, settings)}
				</div>
				<div class={s.specific} style={animStyle}>
					{this.getSingleTheaterSentence(theater, settings)}
				</div>
			</div>
		);
	}

	render(props, { loading, mobile }) {
		let settings = this.settings;
		if (mobile) {
			settings = this.mobileSettings;
		}

		const containerStyle = {
			backgroundColor: color(settings.backgroundColor),
			color: color(settings.textColor),
			fontSize: size(settings.textFontSize)
		};
		const buttonStyles = {
			backgroundColor: color(settings.buttonBackgroundColor),
			color: color(settings.buttonTextColor),
			fontSize: size(settings.buttonFontSize)
		};

		let buttonCTA = this.getCopy('buttonCTA', 'buttonCTABeforeRelease', 'Get Tickets');
		return (
			<div class={joinClasses(s.container, loading && s.loading)} style={containerStyle}>
				{this.getSentence(settings)}
				<Link
					class={s.button}
					href={this.getLink()}
					target="_blank"
					style={buttonStyles}
					trackId="embed-tickets-click"
				>
					{buttonCTA}
				</Link>
			</div>
		);
	}
}
